import React, { useState } from 'react';

const RenewButton = ({ user }) => {
    const [loading, setLoading] = useState(false);
    const [selectedPlan, setSelectedPlan] = useState('pro'); // Default to Pro

    const plans = {
        basic: { name: 'Basic (Monthly)', price: 'R85' },
        pro: { name: 'Pro (Quarterly)', price: 'R199' },
        yearly: { name: 'Yearly (Best Value)', price: 'R699' }
    };

    const handleRenewal = async () => {
        setLoading(true);
        try {
            // 1. Talk to your API
            const response = await fetch(`https://marksure.tech/api/create_public_subscription.php`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    plan: selectedPlan, // Send the chosen plan
                    user_id: user.id    // Send the user ID (Critical for unlocking)
                }),
            });

            const result = await response.json();

            if (result.redirectUrl) {
                // 2. Go to Yoco
                window.location.href = result.redirectUrl;
            } else {
                alert('Connection error: ' + (result.error || 'Unknown error'));
            }
        } catch (error) {
            console.error(error);
            alert('Error initiating payment.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', maxWidth: '300px' }}>
            {/* Plan Selector */}
            <select
                value={selectedPlan}
                onChange={(e) => setSelectedPlan(e.target.value)}
                style={{
                    padding: '10px',
                    borderRadius: '8px',
                    border: '1px solid #ccc',
                    fontSize: '16px',
                    width: '100%'
                }}
            >
                <option value="basic">Basic - R85 / month</option>
                <option value="pro">Pro - R199 / 3 months</option>
                <option value="yearly">Yearly - R699 / year</option>
            </select>

            {/* Pay Button */}
            <button
                onClick={handleRenewal}
                disabled={loading}
                style={{
                    backgroundColor: '#FF9800',
                    color: 'white',
                    padding: '12px 24px',
                    border: 'none',
                    borderRadius: '8px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    cursor: loading ? 'wait' : 'pointer',
                }}
            >
                {loading ? 'Loading Payment...' : `Renew for ${plans[selectedPlan].price}`}
            </button>
        </div>
    );
};

export default RenewButton;